import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedSites from './components/FeaturedSites';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import useScrollToTop from '@/hooks/useScrollToTop';

export default function Home() {
  useScrollToTop();

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '91网址 - 精选网址导航与资源汇聚平台',
            url: 'https://www.91wangzhi.com/',
            description:
              '91网址是一站式网址导航平台，汇聚海量精选优质网址资源，涵盖生活、娱乐、工具、学习等多类别网站推荐。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://www.baidu.com/s?wd={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '91网址',
            url: 'https://www.91wangzhi.com/',
            description:
              '一站式网址导航平台，汇聚海量精选优质网址资源。',
            contactPoint: {
              '@type': 'ContactPoint',
              email: 'contact@91wangzhi.com',
              contactType: 'customer service',
            },
          }),
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryGrid />
          <FeaturedSites />
          <ArticleSection />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}